import {Component, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@lcms/shared/data-access-user';
import { Observable, catchError, of, retry, throwError, mergeMap, Subscription, map, switchMap, tap, delay } from 'rxjs';
import { Router } from '@angular/router';
import {NgxSpinnerModule, NgxSpinnerService} from "ngx-spinner";
import {translate} from "@angular/localize/tools";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'lcms-splash-screen',
  standalone: true,
  imports: [CommonModule , NgxSpinnerModule , TranslateModule ],
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit,OnDestroy  {
  subscription:Subscription;
  isUserCheckd$: Observable<boolean> = this.authService.isUserLogged$.pipe(
    mergeMap(val => val ? of(true) : throwError(() => 'Error!')),
    retry({ count: 4, delay: 200 }),
    catchError(error => {
      console.log('end',error);
      return of(false);
    })
    )

  constructor(private authService:AuthService,private router:Router , private spinner: NgxSpinnerService){
    this.subscription = this.isUserCheckd$.subscribe(val => {
      console.log('isUserCheckd',val);
      if(!val) this.authService.removeAuthFromLocalStorage();
      // this.authService.reloadApp();
      window.location.reload();
    })
  }
  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 300);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    console.log('destroy');

  }


}
